module.exports = "<a [routerLink]=\"[inputWhere]\"  >\n<i class=\"fa {{kind}} {{size}}\" aria-hidden=\"true\">\n\t</i>\n"